import { IconComponent } from '../iconComponentType'


export const NestedCircles: IconComponent = (props) => (
  <svg { ...props } xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.018 14.346">
    <g transform="translate(-127.553 -400.559)">
      <path d="M134.338,414.9c-4.2.013-6.8-2.517-6.785-6.6.013-4.406,3.078-7.737,7.127-7.746,3.624-.009,6.9,3.475,6.892,7.325C141.561,412.119,138.7,414.891,134.338,414.9Zm.166-1.252A5.707,5.707,0,0,0,140.39,408c-.05-3.078-2.85-6.316-5.455-6.31-3.111.007-6.344,3.573-6.274,6.921C128.721,411.5,131.243,413.673,134.5,413.653Z" transform="translate(0)"/>
      <path d="M143.275,421.283c-2.434.006-4.068-1.453-4.094-3.656a4.724,4.724,0,0,1,4.748-4.839,3.79,3.79,0,0,1,3.939,4.105C147.884,419.53,146.057,421.276,143.275,421.283Zm3.276-4.226c.081-1.767-.924-3.021-2.452-3.061a3.721,3.721,0,0,0-3.564,3.562,2.448,2.448,0,0,0,2.346,2.73A3.5,3.5,0,0,0,146.55,417.056Z" transform="translate(-8.689 -9.139)"/>
    </g>
  </svg>
)
